module.exports = function anonymous(locals, escapeFn, include, rethrow
/**/) {
"use strict";
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
        .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
    ; __append("<div class=\"container-sm my-7\"> <h3>Thank you</h3> <p>Your account is now enrolled in the ")
    ; __append(escapeFn( locals.planQuantity ))
    ; __append(" ")
    ; __append(escapeFn( locals.planName ))
    ; __append(" Lookups/")
    ; __append(escapeFn( locals.planInterval ))
    ; __append(" plan. If you need any assistance, we have lots of <a href=\"/docs/api\">docs</a> to get you started.</p> </div> ")
  return __output.join("");

}


//////////////////
// WEBPACK FOOTER
// ./app/components/pages/checkout/success/template.ejs
// module id = 1149
// module chunks = 1